import { render, staticRenderFns } from "./WelcomeScreen.vue?vue&type=template&id=c738393a&scoped=true&"
import script from "./WelcomeScreen.vue?vue&type=script&lang=js&"
export * from "./WelcomeScreen.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeScreen.vue?vue&type=style&index=0&id=c738393a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c738393a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
